.wrapper :global(.iti) {
  display: block;
  width: 100%;
  font-size: var(--mantine-font-size-sm);
  --iti-border-color: var(--mantine-color-default-border);
  --iti-country-selector-bg: var(--mantine-color-default);
  --iti-hover-color: var(--mantine-color-default-hover);
  --iti-icon-color: var(--mantine-color-text);
}

.wrapper :global(.iti__tel-input) {
  height: var(--input-height, 36px);
  padding-left: calc(var(--iti-arrow-padding, 80px) + 6px);
  border-radius: var(--mantine-radius-default);
  border: calc(0.0625rem * var(--mantine-scale)) solid
    var(--mantine-color-default-border);
  background-color: var(--mantine-color-default);
  color: var(--mantine-color-text);
  font-size: var(--mantine-font-size-sm);
  width: 100%;
}

.xs :global(.iti) {
  font-size: var(--mantine-font-size-xs);
}

.xs :global(.iti__tel-input) {
  height: 30px;
  font-size: var(--mantine-font-size-xs);
}

.wrapper :global(.iti__tel-input:focus) {
  outline: none;
  border-color: var(--mantine-primary-color-filled);
}

.wrapper :global(.iti__tel-input:disabled) {
  opacity: 0.6;
  cursor: not-allowed;
}
